import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-191">
      <div className="max-w-2xl mx-auto text-center" data-id="element-192">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-193">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#00B4D8] mb-4" data-id="element-194">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-2xl p-8 mb-6" data-id="element-195">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-196">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en la clase si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-197">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-198">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-199">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-200">
          La confianza que tenemos en el MegaPack Padel Listo nos permite hacer
          esa promesa sin dudar.
          <br data-id="element-201" />
          Más de 300 profes de pádel de todo el país ya lo saben.
          <br data-id="element-202" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}